import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LCard, LButton } from "@loffa/gpp-modules";
import { ProductManagement } from "./ProductManagement/ProductManagement";
import { ClientManagement } from "./ClientManagement/ClientManagement";
import { UserManagement } from "./UserManagement/UserManagement";
import styles from "./ManagementDashboard.module.css";

import { ServiceManagement } from "./ServiceManagement/ServiceManagement";
import { DatamanagerManagement } from "./DatamanagerManagement/DatamanagerManagement";
import { EmailMessageManagement } from "./EmailMessageManagement/EmailMessageManagement";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import ReportsManagment from "./ReportsManagment/ReportsManagment";



library.add(faDatabase);




function ManagementDashboard(props) {

  const [state, setState] = useState({
    view: 0,
    sectionName: "",
  });

  const viewStateChange = (viewNumber) => {
    let newState = { view: viewNumber };
    switch (viewNumber) {
      case 1:
        setState({ ...newState, sectionName: " | Client Management" });
        break;
      case 2:
        setState({ ...newState, sectionName: " | Product Management" });
        break;
      case 3:
        setState({ ...newState, sectionName: " | User Management" });
        break;
      case 4:
        setState({ ...newState, sectionName: " | Service Management" });
        break;
      case 5:
        setState({ ...newState, sectionName: " | Data Manager + Automation" });
        break;
      case 6:
        setState({ ...newState, sectionName: " | Generate Reports" });
        break;
      case 7:
        setState({ ...newState, sectionName: " | Email & Message Management" });
        break;
      default:
        setState({ ...newState, sectionName: "" });
    }
  };

  return (
    <div className={styles.managementDashboard}>
      <div className="sectionTitle">
        <FontAwesomeIcon icon="cog" /> Administration
        {state.view !== 0 && (
          <span className={styles.managementSectionTitle}>
            {state.sectionName}
          </span>
        )}
        {state.view !== 0 && (
          <div className={styles.managementShortcut}>
            <LButton
              look="flat"
              onClick={() => viewStateChange(1)}
              disabled={state.view === 1}
            ><FontAwesomeIcon icon="fa-sharp fa-solid fa-building" /> Clients</LButton>{" "}
            <LButton
              look="flat"
              onClick={() => viewStateChange(2)}
              disabled={state.view === 2}
            ><FontAwesomeIcon icon="fa-solid fa-grid-2-plus" /> Products</LButton>{" "}
            <LButton
              look="flat"
              onClick={() => viewStateChange(3)}
              disabled={state.view === 3}
            ><FontAwesomeIcon icon="fa-solid fa-users-gear" /> Users</LButton>
            <LButton
              look="flat"
              onClick={() => viewStateChange(4)}
              tooltip="Service Management"
              tooltipPosition="bottomRight"
              disabled={state.view === 4}
            ><FontAwesomeIcon icon="fa-screwdriver-wrench" /> Services</LButton>

          <LButton
            look="flat"
            onClick={() => viewStateChange(5)}
            tooltip="Data Manager and Automation Management - Update/Add Templates, set up jobs and more."
            tooltipPosition="bottomRight"
            disabled={state.view === 5}
          >
            <FontAwesomeIcon icon={faDatabase} /> Data Manager + Automation
          </LButton>

          <LButton
            look="flat"
            onClick={() => viewStateChange(6)}
            tooltip="Reports Management"
            tooltipPosition="bottomRight"
            disabled={state.view === 6}
          >
            <FontAwesomeIcon icon={faDatabase} /> Reporting
          </LButton>
          
          <LButton
            look="flat"
            onClick={() => viewStateChange(7)}
            tooltip="Email & Message Management"
            tooltipPosition="bottomRight"
            disabled={state.view === 7}
          >
            <FontAwesomeIcon icon="fa-solid fa-envelope"/> Email & Message Management
          </LButton>

          </div>
        )}
      </div>
      {state.view === 0 && (
        <div className={styles.managementCards}>
          <LCard
            className={styles.managementCard}
            style={{ width: "300px" }}
            title={
              <div>
                <FontAwesomeIcon
                  className={styles.managementIcon}
                  icon="fa-sharp fa-solid fa-building"
                />
                <br />
                Client Management
              </div>
            }
            subtitle="Create and manage new clients and configure their products and users"
            clickAction={() => viewStateChange(1)}
          ></LCard>
          <LCard
            className={styles.managementCard}
            style={{ width: "300px" }}
            title={
              <div>
                <FontAwesomeIcon
                  className={styles.managementIcon}
                  icon="fa-solid fa-grid-2-plus"
                />
                <br />
                Product Management
              </div>
            }
            subtitle="Create and manage products and configure their global settings"
            clickAction={() => viewStateChange(2)}
          ></LCard>
          <LCard
            className={styles.managementCard}
            style={{ width: "300px" }}
            title={
              <div>
                <FontAwesomeIcon
                  className={styles.managementIcon}
                  icon="fa-solid fa-users-gear"
                />
                <br />
                User Management
              </div>
            }
            subtitle="Create and manage users including administrators"
            clickAction={() => viewStateChange(3)}
          ></LCard>

          <LCard
            className={styles.managementCard}
            style={{ width: "300px" }}
            title={
              <div>
                <FontAwesomeIcon
                  className={styles.managementIcon}
                  icon="fa-screwdriver-wrench"
                />
                <br />
                Service Management
              </div>
            }
            subtitle="Manage services and their configurations"
            clickAction={() => viewStateChange(4)}
          ></LCard>


          <LCard
            className={styles.managementCard}
            style={{ width: "300px" }}
            title={
              <div>
                <FontAwesomeIcon
                  className={styles.managementIcon}
                  icon="fa-database"
                />
                <br />
                Data Manager + Automation
              </div>
            }
            subtitle="Data Manager and Automation Management - Update/Add Templates, set up jobs and more."
            clickAction={() => viewStateChange(5)}
          ></LCard>

          <LCard
            className={styles.managementCard}
            style={{ width: "300px" }}
            title={
              <div>
                <FontAwesomeIcon
                  className={styles.managementIcon}
                  icon="fa-file-invoice"
                />
                <br />
                Reporting
              </div>
            }
            subtitle="Generate and Export Reports"
            clickAction={() => viewStateChange(6)}
          ></LCard>

          <LCard
            className={styles.managementCard}
            style={{ width: "300px" }}
            title={
              <div>
                <FontAwesomeIcon
                  className={styles.managementIcon}
                  icon="fa-solid fa-envelope"
                />
                <br />
                Email & Message Management
              </div>
            }
            subtitle="Manage email templates and messaging configurations"
            clickAction={() => viewStateChange(7)}
          ></LCard>
        </div>
      )}
      {state.view !== 0 && (
        <div className={styles.managementViewContainer}>
          {state.view === 1 && <ClientManagement />}
          {state.view === 2 && <ProductManagement />}
          {state.view === 3 && <UserManagement />}
          {state.view === 4 && <ServiceManagement />}
          {state.view === 5 && <DatamanagerManagement />}
          {state.view === 6 && <ReportsManagment />}
          {state.view === 7 && <EmailMessageManagement />}
        </div>
      )}
    </div>
  );
}

export { ManagementDashboard };
